export const initViewport = {
    latitude: 42.09144159848355,
    longitude: -101.63223681769762,
    zoom: 3.0,
    bearing: 0,
    pitch: 0,
    height: '100vh',
    width: '100vw',
};
